/**
 * Initializes one category shelf carousel.
 * @param {HTMLElement} section
 */
function initializeCategoryShelf(section) {
  if (section.dataset.initialized === 'true') return;

  const swiperElement = section.querySelector('[data-category-shelf-swiper]');
  if (!(swiperElement instanceof HTMLElement) || typeof window.Swiper !== 'function') return;

  section.dataset.initialized = 'true';
  const paginationElement = section.querySelector('[data-category-shelf-pagination]');

  section.categoryShelfSwiper = new window.Swiper(swiperElement, {
    slidesPerView: 1.3,
    spaceBetween: 12,
    watchOverflow: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
    },
    navigation: {
      nextEl: section.querySelector('[data-category-shelf-next]'),
      prevEl: section.querySelector('[data-category-shelf-prev]'),
    },
    pagination: paginationElement
      ? {
          el: paginationElement,
          clickable: true,
        }
      : false,
    breakpoints: {
      480: {
        slidesPerView: 2.5,
      },
      550: {
        slidesPerView: 2.2,
      },
      750: {
        slidesPerView: 3,
      },
      994: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });
}

function initializeCategoryShelves(scope = document) {
  scope.querySelectorAll('[data-category-shelf]').forEach((section) => {
    if (section instanceof HTMLElement) initializeCategoryShelf(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeCategoryShelves(), { once: true });
} else {
  initializeCategoryShelves();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initializeCategoryShelves(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target instanceof Element ? event.target.querySelector('[data-category-shelf]') : null;
  section?.categoryShelfSwiper?.destroy(true, true);
});
